import script from "./LoadingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoadingComponent.vue?vue&type=style&index=0&id=45561fcc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45561fcc"]])

export default __exports__